import {
    getSimilarPin,
    IconCurrentOffer,
    createIcon,
    createInfrastructureIcon,
    MEDICINE_ICON,
    SCHOOL_ICON,
    KINDERGARDEN_ICON,
    LEBENSMITTELGESCHEFT_ICON
} from "./pin_constructor.js";
import {fetchSimilarObjects, fetchInfrastructure} from './api.js';

const OFFER_PIN_ID = 'currentOfferIcon';

if (!document.querySelector('script[src="https://enterprise.api-maps.yandex.ru/2.1/?apikey=9614a954-a8c9-455f-bd7f-978887569cce&lang=ru-RU&load=package.system"]')) {
    const scriptElement = document.createElement('script');
    scriptElement.src = 'https://enterprise.api-maps.yandex.ru/2.1/?apikey=9614a954-a8c9-455f-bd7f-978887569cce&lang=ru-RU&load=package.system';
    document.head.appendChild(scriptElement);
}

if (!customElements.get('cian-content-same-objects-map')) {
    customElements.define('cian-content-same-objects-map', class extends HTMLElement {
        constructor() {
            super();
            const loadMap = () => {
                if (typeof ymaps === 'undefined') {
                    setTimeout(loadMap, 200);
                } else {
                    ymaps.load((YMaps) => {
                        ymaps.ready({
                            require: [
                                'Map',
                                'GeoObject',
                                'ObjectManager',
                                'templateLayoutFactory',
                                'geometry.pixel.Rectangle',
                                'util.bounds',
                                'shape.Rectangle',
                                'control.RulerControl',
                                'objectManager.addon.objectsBalloon',
                                'geoObject.addon.hint',
                                'Placemark',
                            ],
                            successCallback: () => {
                                this.map = new YMaps.Map(this, {
                                    center: [this.getFloatAttribute("lat"), this.getFloatAttribute("lng")],
                                    zoom: 14,
                                    controls: this.hasAttribute('static-map') ? [] : ['zoomControl', 'rulerControl']
                                });
                                this.map.events.add('click', () => {
                                    const fullScreen = document.querySelector('[map-fullscreen]');
                                    if (fullScreen) {
                                        fullScreen.remove();
                                    } else if (this.hasAttribute('static-map')) {
                                        const fullScreen = this.cloneNode();
                                        fullScreen.removeAttribute('static-map');
                                        fullScreen.setAttribute('map-fullscreen', "");
                                        fullScreen.style.position = 'fixed';
                                        fullScreen.style.top = '0';
                                        fullScreen.style.left = '0';
                                        fullScreen.style.width = '100vw';
                                        fullScreen.style.height = '100vh';
                                        document.body.appendChild(fullScreen);
                                    }
                                });
                                if (this.hasAttribute('static-map')) {
                                    this.map.behaviors.disable('drag')
                                } else {
                                    this.map.behaviors.disable('scrollZoom');
                                }

                                this.mapObjectManager = new ymaps.ObjectManager();
                                this.map.geoObjects.add(this.mapObjectManager);

                                this.mapObjectManager.add([createIcon([this.getFloatAttribute("lat"), this.getFloatAttribute("lng")], OFFER_PIN_ID, IconCurrentOffer, 10)]);

                                this.map.events.add('boundschange', () => this.debouncedUpdateSimilarHandler());
                                this.fetchSimilar();
                            }
                        });
                    });
                }
            };
            loadMap();
        }

        debouncedUpdateSimilarHandler() {
            this.fetchSimilar();
        }

        fetchSimilar() {
            const bounds = this.map.getBounds();
            fetchSimilarObjects(bounds, (objects) => {
                this.hideSimilar();
                this.showSimilar(objects.data.points);
            });
        }

        showSimilar(points) {
            const similarPointsIcons = [];

            for (let point in points) {
                if (points.hasOwnProperty(point)) {
                    if (similarPointsIcons.length < 100) {
                        similarPointsIcons.push(
                            createIcon(
                                point.split(' ').map(Number).reverse(),
                                point,
                                getSimilarPin(points[point], false),
                                1,
                            ),
                        );
                    }
                }
            }

            this.mapObjectManager.add(similarPointsIcons);
            this.mapSimilarObjects = similarPointsIcons;
        }

        hideSimilar() {
            if (this.mapSimilarObjects) {
                this.mapObjectManager.remove(this.mapSimilarObjects);
                this.mapSimilarObjects = null;
            }
        }

        getFloatAttribute(name) {
            return Number.parseFloat(this.getAttribute(name));
        }
    });
}
if (!customElements.get('cian-content-infrastructure-map')) {
    customElements.define('cian-content-infrastructure-map', class extends HTMLElement {
        static get observedAttributes() {
            return ['medicine', 'school', 'kindergarden', 'lebensmittelgescheft']
        }

        attributeChangedCallback() {
            this.updatePoints();
        }

        connectedCallback() {
            const showInfrastructure = this.getAttribute('showInfrastructure');
            const buttonContainer = document.createElement('div');
            buttonContainer.style.position = 'absolute';
            buttonContainer.style.zIndex = '10';
            buttonContainer.style.top = '20px';
            buttonContainer.style.left = '20px';
            buttonContainer.innerHTML = `
            <div class="cian-map-elements-infra__container" style="display: flex;">
                <div infra="school" style="display: flex; align-items: center; justify-content: center; cursor: pointer; text-align: center; padding: 5px 8px; background: #FFFFFF;border: 2px solid transparent; --sel-color: #508BE2; box-sizing: border-box;box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);border-radius: 4px;">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.25 3.91699V14L2.45 11.861C2.15 11.785 2 11.48 2 11.174V2.76999C2 2.53999 2.15 2.31199 2.3 2.15999C2.525 2.00699 2.825 1.92999 3.05 2.08299L7.25 3.91699ZM13.7 2.15999C13.85 2.31199 14 2.54199 14 2.76999V11.25C14 11.556 13.85 11.785 13.55 11.937L8.75 14V3.91699L13.025 2.08299C13.25 2.00699 13.475 2.00699 13.7 2.15999Z" fill="#262C40"/>
                    </svg>
                    <div style="margin-left: 4px">Школы</div>
                </div>
                <div infra="kindergarden" style="margin-left: 8px; display: flex; align-items: center; justify-content: center; cursor: pointer; text-align: center; padding: 5px 8px; background: #FFFFFF;border: 2px solid transparent; --sel-color: #4AD3E3;box-sizing: border-box;box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);border-radius: 4px;">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11.9571 7.32229C12.5307 7.32229 13 7.76633 13 8.30863C13 8.85093 12.5307 9.29497 11.9443 9.29497H10.2236C10.2371 9.36848 10.2371 9.42999 10.2371 9.50499V10.5153C10.2371 10.6263 10.2236 10.7494 10.2107 10.8731L12.0486 12.0072C12.4786 12.4633 12.4786 13.1413 12.0486 13.5974C11.5786 14.0902 10.77 14.1397 10.2486 13.6956L9.37571 12.8706C8.92902 13.1077 8.43552 13.2312 7.935 13.2312C7.43448 13.2312 6.94098 13.1077 6.49429 12.8706L5.62071 13.6956C5.15143 14.0902 4.43429 14.0902 3.95143 13.6956C3.43 13.2651 3.37857 12.5 3.83429 12.0072L5.685 10.8484C5.66926 10.7298 5.66043 10.6103 5.65857 10.4906V9.47949C5.65857 9.40598 5.67214 9.33173 5.67214 9.26947H4.04286C3.46857 9.27022 3 8.82768 3 8.28463C3 7.74233 3.46929 7.29829 4.04286 7.29829H5.58143C5.67286 7.29829 5.75071 7.31104 5.84214 7.33579C5.19 6.76799 4.81214 5.97892 4.81214 5.14109C4.81214 4.99332 4.825 4.83281 4.85143 4.68505C4.60661 4.60136 4.38661 4.45251 4.21286 4.25301C3.70429 3.66195 3.80857 2.78662 4.43429 2.30583C5.06 1.82503 5.98571 1.92329 6.49429 2.51509C6.94885 2.28988 7.44524 2.17308 7.94786 2.17308C8.45048 2.17308 8.94687 2.28988 9.40143 2.51509C9.57071 2.31783 9.79286 2.17006 10.0407 2.0838C10.81 1.82503 11.6443 2.19481 11.9307 2.92163C12.205 3.6492 11.8136 4.45027 11.0571 4.7098C11.2271 5.72014 10.8357 6.74399 10.0143 7.4093C10.146 7.34992 10.2881 7.32053 10.4314 7.32304H11.9571V7.32229ZM9.93571 2.80987L10.0407 2.93363C10.275 3.11815 10.4707 3.34017 10.6271 3.58619L10.9529 3.94473C11.0294 3.88593 11.0932 3.8107 11.1399 3.72404C11.1866 3.63738 11.2153 3.54127 11.2239 3.4421C11.2326 3.34292 11.221 3.24295 11.1901 3.14881C11.1591 3.05468 11.1094 2.96855 11.0443 2.89613C10.7707 2.5886 10.275 2.5511 9.93643 2.80987H9.93571ZM7.26429 6.3607C7.18571 6.28644 7.06857 6.28644 7.00357 6.3607C6.93786 6.43496 6.93786 6.54597 7.01643 6.60747C7.53786 7.10027 8.385 7.10027 8.90714 6.60747C8.98571 6.53322 8.98571 6.43496 8.90714 6.3607C8.87222 6.3251 8.82546 6.30518 8.77679 6.30518C8.72811 6.30518 8.68135 6.3251 8.64643 6.3607C8.50286 6.48371 8.33286 6.57072 8.13786 6.60747V5.89191C8.47643 5.65789 8.46357 5.37436 8.46357 5.37436C8.46357 5.2266 8.34643 5.11559 8.19 5.10358H7.72071C7.68571 5.10218 7.65079 5.1081 7.61798 5.121C7.58518 5.13389 7.55514 5.15351 7.52962 5.17871C7.5041 5.2039 7.4836 5.23417 7.46932 5.26776C7.45504 5.30135 7.44726 5.33759 7.44643 5.37436C7.46 5.58438 7.57714 5.7809 7.77286 5.89191V6.60747C7.58591 6.57262 7.41072 6.48762 7.26429 6.3607ZM4.95571 3.95673L5.26857 3.59895C5.43786 3.35292 5.63357 3.1309 5.855 2.94638L5.97286 2.82262C5.64643 2.5511 5.15143 2.6006 4.86429 2.90888C4.79649 2.97979 4.74442 3.06553 4.71178 3.15999C4.67915 3.25445 4.66676 3.3553 4.67549 3.45537C4.68422 3.55543 4.71386 3.65224 4.7623 3.7389C4.81073 3.82556 4.87677 3.89994 4.95571 3.95673ZM6.43786 4.99933C6.61 4.99933 6.75 4.86431 6.75 4.6993C6.75 4.53428 6.61 4.39927 6.43714 4.39927C6.265 4.39927 6.125 4.53428 6.125 4.6993C6.125 4.86431 6.265 4.99933 6.43786 4.99933ZM9.56286 4.99933C9.735 4.99933 9.875 4.86431 9.875 4.6993C9.875 4.53428 9.735 4.39927 9.56214 4.39927C9.39 4.39927 9.25 4.53428 9.25 4.6993C9.25 4.86431 9.39 4.99933 9.56286 4.99933Z" fill="#262C40"/>
                    </svg>
                    <div style="margin-left: 4px">Детские сады</div>
                </div>
                <div infra="medicine" style="margin-left: 8px; display: flex; align-items: center; justify-content: center; cursor: pointer; text-align: center; padding: 5px 8px; background: #FFFFFF;border: 2px solid transparent; --sel-color: #4ACC67;box-sizing: border-box;box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);border-radius: 4px;">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.25 5.75H10.25V2.75C10.25 2.3 9.95 2 9.5 2H6.5C6.05 2 5.75 2.3 5.75 2.75V5.75H2.75C2.3 5.75 2 6.05 2 6.5V9.5C2 9.95 2.3 10.25 2.75 10.25H5.75V13.25C5.75 13.7 6.05 14 6.5 14H9.5C9.95 14 10.25 13.7 10.25 13.25V10.25H13.25C13.7 10.25 14 9.95 14 9.5V6.5C14 6.05 13.7 5.75 13.25 5.75Z" fill="#262C40"/>
                    </svg>
                    <div style="margin-left: 4px">Поликлиники</div>
                </div>
                <div infra="lebensmittelgescheft" style="margin-left: 8px; display: flex; align-items: center; justify-content: center; cursor: pointer; text-align: center; padding: 5px 8px; background: #FFFFFF;border: 2px solid transparent; --sel-color: #FF9900;box-sizing: border-box;box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);border-radius: 4px;">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M13.278 4.25C13.88 4.25 14.105 4.85 13.955 5.225L12.451 9.725C12.409 9.87332 12.3206 10.0043 12.1988 10.0988C12.077 10.1932 11.9281 10.2462 11.774 10.25H5.76C5.384 10.25 5.084 10.025 5.009 9.65L3.654 3.5H2V2H4.256C4.632 2 4.932 2.225 5.008 2.6L5.383 4.25H13.278ZM5.76 14C4.93 14 4.257 13.328 4.257 12.5C4.257 11.672 4.929 11 5.759 11C6.589 11 7.263 11.672 7.263 12.5C7.263 13.328 6.59 14 5.76 14ZM11.775 14C10.945 14 10.272 13.328 10.272 12.5C10.272 11.672 10.944 11 11.774 11C12.604 11 13.278 11.672 13.278 12.5C13.278 13.328 12.605 14 11.774 14H11.775Z" fill="#262C40"/>
                    </svg>
                    <div style="margin-left: 4px">Продовольственные магазины</div>
                </div>
            </div>
        `;
            this.addEventListener('click', e => {
                const infoBox = e.target.closest('[infra]');
                const attribute = infoBox.getAttribute('infra');
                if (attribute) {
                    if (this.hasAttribute(attribute)) {
                        this.removeAttribute(attribute);
                        infoBox.style.borderColor = "transparent";
                    } else {
                        this.setAttribute(attribute, "true");
                        infoBox.style.borderColor = "var(--sel-color)";
                    }
                    this.querySelectorAll('[infra]').forEach(v => {
                    })
                }
            });

            showInfrastructure === 'true' && this.appendChild(buttonContainer);
            const loadMap = () => {
                if (typeof ymaps === 'undefined') {
                    setTimeout(loadMap, 200);
                } else {
                    ymaps.load((YMaps) => {
                        ymaps.ready({
                            require: [
                                'Map',
                                'GeoObject',
                                'ObjectManager',
                                'templateLayoutFactory',
                                'geometry.pixel.Rectangle',
                                'util.bounds',
                                'shape.Rectangle',
                                'control.RulerControl',
                                'objectManager.addon.objectsBalloon',
                                'geoObject.addon.hint',
                                'Placemark',
                            ],
                            successCallback: () => {
                                this.map = new YMaps.Map(this, {
                                    center: [this.getFloatAttribute("lat"), this.getFloatAttribute("lng")],
                                    zoom: 14,
                                    controls: ['zoomControl', 'rulerControl']
                                });
                                this.map.behaviors.disable('scrollZoom');

                                this.mapObjectManager = new ymaps.ObjectManager();
                                this.map.geoObjects.add(this.mapObjectManager);
                                this.mapObjectManager.add([createIcon([this.getFloatAttribute("lat"), this.getFloatAttribute("lng")], OFFER_PIN_ID, IconCurrentOffer, 10)]);

                                showInfrastructure === 'true' && this.fetchInfrastructure();
                            }
                        });
                    });
                }
            };
            loadMap();
        }

        async fetchInfrastructure() {
            const bounds = this.getBoundingClientRect();
            const offerId = this.getAttribute('offer-id');
            try {
                const { infrastructure } = await fetchInfrastructure(offerId, bounds);
                this.infra = infrastructure;
                this.updatePoints();
            } catch(_) {
                this.updatePoints();
            }


        }

        updatePoints() {
            if (!this.mapObjectManager) {
                return;
            }
            this.mapObjectManager.removeAll();
            this.mapObjectManager.add([createIcon([this.getFloatAttribute("lat"), this.getFloatAttribute("lng")], OFFER_PIN_ID, IconCurrentOffer, 10)]);
            //Medicine
            if (this.hasAttribute('medicine')) {
                const medicine = this.infra[0].items;
                this.medicineIcons = [];
                for (let point of medicine) {
                    this.medicineIcons.push(createInfrastructureIcon(
                        [point.coordinates.lat, point.coordinates.lon],
                        `med_${[point.coordinates.lat, point.coordinates.lon].join(" ")}`,
                        MEDICINE_ICON,
                        1,
                    ));
                }
                this.mapObjectManager.add(this.medicineIcons);
            }
            //School
            if (this.hasAttribute('school')) {
                const school = this.infra[3].items;
                this.schoolIcons = [];
                for (let point of school) {
                    this.schoolIcons.push(createInfrastructureIcon(
                        [point.coordinates.lat, point.coordinates.lon],
                        `sch_${[point.coordinates.lat, point.coordinates.lon].join(" ")}`,
                        SCHOOL_ICON,
                        1,
                    ));
                }
                this.mapObjectManager.add(this.schoolIcons);
            }
            //Kindergarden
            if (this.hasAttribute('kindergarden')) {
                const kindergarden = this.infra[2].items;
                this.kindergardenIcons = [];
                for (let point of kindergarden) {
                    this.kindergardenIcons.push(createInfrastructureIcon(
                        [point.coordinates.lat, point.coordinates.lon],
                        `kid_${[point.coordinates.lat, point.coordinates.lon].join(" ")}`,
                        KINDERGARDEN_ICON,
                        1,
                    ));
                }
                this.mapObjectManager.add(this.kindergardenIcons);
            }
            //Lebensmittelgesheft
            if (this.hasAttribute('lebensmittelgescheft')) {
                const lebensmittelgescheft = this.infra[1].items;
                this.lebensmittelgescheftIcons = [];
                for (let point of lebensmittelgescheft) {
                    this.lebensmittelgescheftIcons.push(createInfrastructureIcon(
                        [point.coordinates.lat, point.coordinates.lon],
                        `shop_${[point.coordinates.lat, point.coordinates.lon].join(" ")}`,
                        LEBENSMITTELGESCHEFT_ICON,
                        1,
                    ));
                }
                this.mapObjectManager.add(this.lebensmittelgescheftIcons);
            }
        }

        getFloatAttribute(name) {
            return Number.parseFloat(this.getAttribute(name));
        }

    });
}

if (!customElements.get('cian-mobile-infrastructure-map')) {
    customElements.define('cian-mobile-infrastructure-map', class extends HTMLElement {
        connectedCallback() {
            this.offerId = this.getAttribute('offer-id');
            this.lat = this.getAttribute('lat');
            this.lng = this.getAttribute('lng');
            this.render();
            const modal = document.getElementById('map-modal');
            this.getElementsByClassName('cian-mobile-map-overlay')[0].addEventListener('click', ({target}) => {
                console.log("click on overlay");
                modal.classList.remove('full-screen-map-hide');
            });
            this.getElementsByClassName('map-hide-button')[0].addEventListener('click', ({target}) => {
                console.log('click on hide button');
                modal.classList.add('full-screen-map-hide');
            })
        }

        handleMapModal = (action) => ({target}) => {
            const modal = document.getElementById('map-modal');
            if (action === 'open') {
                modal.classList.remove('full-screen-map-hide');
            }
            if (action === 'close') {
                modal.classList.add('full-screen-map-hide');
            }
        }

        render() {
            this.innerHTML = `
                <div class="cian-jk-card-map-mobile">
                    <div class="cian-mobile-map-overlay" id="cian-mobile-map-overlay"></div>
                    <div class="full-screen-map full-screen-map-hide" id="map-modal">
                        <div class="map-hide-button" id="map-hide-button">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.4142 12L17.7072 7.707C18.0982 7.316 18.0982 6.684 17.7072 6.293C17.3162 5.902 16.6842 5.902 16.2933 6.293L12.0002 10.586L7.70725 6.293C7.31625 5.902 6.68425 5.902 6.29325 6.293C5.90225 6.684 5.90225 7.316 6.29325 7.707L10.5862 12L6.29325 16.293C5.90225 16.684 5.90225 17.316 6.29325 17.707C6.48825 17.902 6.74425 18 7.00025 18C7.25625 18 7.51225 17.902 7.70725 17.707L12.0002 13.414L16.2933 17.707C16.4882 17.902 16.7443 18 17.0002 18C17.2562 18 17.5122 17.902 17.7072 17.707C18.0982 17.316 18.0982 16.684 17.7072 16.293L13.4142 12Z" fill="#262C40"/>
                            </svg>
                        </div>
                        <cian-content-infrastructure-map offer-id="${this.offerId}" lat="${this.lat}" lng="${this.lng}" style="position: relative; display: block; background: white; width: 100%; height: 100%"></cian-content-infrastructure-map>
                    </div>
                    <cian-content-infrastructure-map
                        offer-id="${this.offerId}"
                        lat="${this.lat}"
                        lng="${this.lng}"
                        style="position: relative; display: block; background: white; width: 100%; height: 100%"
                    ></cian-content-infrastructure-map>
                </div>

                <style>
                    .cian-jk-card-map-mobile {
                        position: relative;
                        height: 60vw;
                    }

                    .cian-mobile-map-overlay {
                        position: absolute;
                        width: 100%;
                        height: 100%;
                        z-index: 7;
                    }
                    .full-screen-map {
                        position: fixed;
                        z-index: 999999999;
                        left: 0;
                        top: 0;
                        width: 100%;
                        height: 100%;
                        min-height: 160px;
                        overflow: auto;
                        background-color: white;
                      }

                      .map-hide-button {
                        position: absolute;
                        height: 40px;
                        width: 40px;
                        background-color: white;
                        border-radius: 20px;
                        top: 16px;
                        right: 16px;
                        z-index: 1;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.15);
                      }
                      
                      .full-screen-map-hide {
                        display: none;
                      }
                </style>
            `
        }
    });
}
